module.exports = __webpack_public_path__ + "src/images/my-reads.81089ad907b6a8bf0da052940301a553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/my-reads.jpg
// module id = 124
// module chunks = 0